import { combineReducers } 	from 'redux';
import accountReducer 		from './accountReducer';
import {
	clearStoreReducer,
	stagesReducer,
	levelsReducer,
	singleLevelReducer,
	accountsReducer,
	usersReducer,
	currenciesReducer,
	countriesReducer,
	schoolTypesReducer,
	classRoomsReducer,
	playersReducer,
	teachersReducer,
	settingsReducer,
	badgesReducer,
	partsReducer,
} from './contentReducers';

export default combineReducers({
    account: accountReducer,
	clearStore: clearStoreReducer,
    stages: stagesReducer,
	levels: levelsReducer,
	singleLevel: singleLevelReducer,
    accounts: accountsReducer,
    users: usersReducer,
    currencies: currenciesReducer,
    countries: countriesReducer,
    schoolTypes: schoolTypesReducer,
    classRooms: classRoomsReducer,
    players: playersReducer,
	teachers: teachersReducer,
	settings: settingsReducer,
	badges: badgesReducer,
	parts: partsReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js